import ImportComponent from './components/ImportComponent.vue'
import { store } from './stores/'

export default {
  elementId: 'importQuestion',
  rootComponent: ImportComponent,
  stores: [
    {
      key: ['Import'],
      module: store
    }
  ]
}
